import React, { useState, useEffect, useRef, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
// import MasterNumber from '../../YourInformation/components/MasterNumber'
// import PlateNumber from '../../YourInformation/components/PlateNumber'
// import VinSerialNumber from '../../YourInformation/components/VinSerialNumber'
import { clearListInfoAction, listAddAction } from 'redux/actions'
import moment from 'moment-timezone'
import FirstName from '../../PersonalInformation/components/FirstName'
import LastName from '../../PersonalInformation/components/LastName'
import DateOfBirth from '../../PersonalInformation/components/DateOfBirth'
import MasterNumber from '../../PersonalInformation/components/MasterNumber'
import NSHealthCardNumber from '../../PersonalInformation/components/NSHealthCardNumber'
import styles from './HouseholdList.module.scss';
import { findDuplicateMasterNumber, isSameMember } from "../../../../redux/reducers/appReducer";
import { validateNSHealthNumber } from '../../../../shared/helpers/validateNSHealthCardNumber'

// import { processMasterNumberAction } from 'redux/reducers/apiReducers/processMasterNumberReducer'
// import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
var unidecode = require('unidecode')
const AddHouseholdMemberView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch()

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [firstNameValid, setFirstNameValid] = useState('')
  const [lastNameValid, setLastNameValid] = useState('')
  const [dateOfBirthValid, setDateOfBirthValid] = useState('')
  const [masterNumberValid, setMasterNumberValid] = useState('')
  const [nsHealthCardNumberValid, setNSHealthCardNumberValid] = useState('')

  const [firstNameError, setFirstNameError] = useState('personal_info.first_name_error')
  const [lastNameError, setLastNameError] = useState('personal_info.last_name_error')
  const [dateOfBirthError, setDateOfBirthError] = useState('personal_info.date_of_birth_error')
  const [masterNumberError, setMasterNumberError] = useState('personal_info.master_number_error')
  const [nsHealthCardNumberError, setNSHealthCardNumberError] = useState('personal_info.ns_health_card_number_error')

  const dateOfBirthDayEl = useRef(null)
  const dateOfBirthMonthEl = useRef(null)
  const dateOfBirthYearEl = useRef(null)

  const [errMsg, setErrMsg] = useState('');
  const personalInformation = useSelector((state) => state.app.personalInformation)
  const { dateOfBirth, firstName, lastName, masterNumber, nsHealthCardNumber, masterNumberDOB, houseHoldMembers } = personalInformation;
  const jointVehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles);
  const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles);

  const { nsHealthCard, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  useEffect(() => {
    try {
      dispatch(clearListInfoAction("personalInformation"))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [dispatch, setIsError])

  const onAddHouseholdMember = () => {
    try {
      const newMember = {
        dateOfBirth, firstName, lastName, masterNumber, nsHealthCardNumber, masterNumberDOB
      }
      const foundDup = isDuplicate(newMember)
      if (validateFields() && !foundDup) {
        dispatch(listAddAction("personalInformation", newMember));
        dispatch(clearListInfoAction("personalInformation"))
        setFirstNameValid('');
        setLastNameValid('')
        setDateOfBirthValid('')
        setMasterNumberValid('')
        setNSHealthCardNumberValid('')

        setErrMsg('')
        window.scrollTo(0, 0)
      }
    } catch (e) {
      console.log(e)
      // setErrMsg('your_information.service_not_available_error')
    }
  }
  const isDuplicate = useCallback((newHouseholdMember) => {

    const foundDuplicate = houseHoldMembers.find((member) => isSameMember(nsHealthCard, member, newHouseholdMember));
    const duplicateMasterNumber = findDuplicateMasterNumber(newHouseholdMember.masterNumber, houseHoldMembers, jointVehicles, businessVehicles);
    if (foundDuplicate || duplicateMasterNumber) {
      setErrMsg('household_list.found_duplicate')
    } else {
      setErrMsg('')
    }
    return foundDuplicate || duplicateMasterNumber
  }, [houseHoldMembers, jointVehicles, businessVehicles, setErrMsg, nsHealthCard]);

  const validateFields = () => {
    try {

      validateLastName(lastName)
      validateDateOfBirth(dateOfBirth)
      // if (driverLicence || registeredByName) {
      validateMasterNumber(masterNumber)
      // }
      console.log('test', firstName)
      if (firstName) {
        validateFirstName(firstName)
      }
      if (nsHealthCard) {
        validateNSHealthCardNumber(nsHealthCardNumber)
      }
      if (lastName === '') {
        setLastNameValid(false)
      }
      if (dateOfBirth === '') {
        setDateOfBirthValid(false)
      }
      // if ((driverLicence || registeredByName) && masterNumber === '') {
      //   setMasterNumberValid(false)
      // }
      if (nsHealthCard && nsHealthCardNumber === '') {
        setNSHealthCardNumberValid(false)
      }

      const testOptionalMasterCard = (nsHealthCard ? (masterNumberValid || masterNumberValid === '') : masterNumberValid)
      return (
        firstNameValid === true &&
        lastNameValid === true &&
        dateOfBirthValid === true &&
        testOptionalMasterCard &&
        // ((driverLicence || registeredByName) ? masterNumberValid === true : true) &&
        (nsHealthCard ? nsHealthCardNumberValid === true : true) &&
        lastName !== '' &&
        dateOfBirth !== '' &&
        // ((driverLicence || registeredByName) ? masterNumber !== '' : true) &&
        (nsHealthCard ? nsHealthCardNumber !== '' : true)
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFirstName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (regex.test(name)) {
        setFirstNameValid(true)
      } else {
        setFirstNameValid(false)
        setFirstNameError('personal_info.first_name_error_invalid')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateLastName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          setLastNameValid(true)
        } else {
          setLastNameValid(false)
          setLastNameError('personal_info.last_name_error_invalid')
        }
      } else {
        setLastNameValid(false)
        setLastNameError('personal_info.last_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  const validateDateOfBirth = () => {
    try {
      let dayRegex = RegExp(/^\d{2}$/)
      let monthRegex = RegExp(/^\d{2}$/)
      let yearRegex = RegExp(/^\d{4}$/)
      if (
        dayRegex.test(dateOfBirthDayEl.current.value) &&
        monthRegex.test(dateOfBirthMonthEl.current.value) &&
        yearRegex.test(dateOfBirthYearEl.current.value)
      ) {
        let inputDate = `${dateOfBirthYearEl.current.value}-${dateOfBirthMonthEl.current.value}-${dateOfBirthDayEl.current.value}`
        if (moment(inputDate).isValid()) {
          if (
            !moment(inputDate).isAfter(moment().format('YYYY-MM-DD'), 'day')
          ) {
            setDateOfBirthValid(true)
          } else {
            setDateOfBirthValid(false)
            setDateOfBirthError('personal_info.date_of_birth_error')
          }
        } else {
          setDateOfBirthValid(false)
          setDateOfBirthError('personal_info.date_of_birth_error')
        }
      } else {
        setDateOfBirthValid(false)
        setDateOfBirthError('personal_info.date_of_birth_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getParsedMasterNumber = () => {
    let number = ''
    let parsedLastName = lastName.replace(/[^a-zA-Z àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]/g, '')
    if (lastName && lastName[0].toLocaleLowerCase() === 'm' && lastName[1].toLocaleLowerCase() === 'c') {
      number = 'MAC'
      number = number + (parsedLastName[2] === undefined ? ' ' : parsedLastName[2])
      number = number + (parsedLastName[3] === undefined ? ' ' : parsedLastName[3])
    } else {
      for (let i = 0; i < 5; i++) {
        number = number + (parsedLastName[i] === undefined ? ' ' : parsedLastName[i])
      }
    }
    number = number + masterNumberDOB
    return number
  }

  const validateMasterNumber = (masterNumberElem) => {
    const isOptional = nsHealthCard;
    if (masterNumberElem.length === 0) {
      if (isOptional) {
        setMasterNumberValid('')
        return true;
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('personal_info.master_number_error_empty')
        return false
      }
    }
    if (lastName && lastName.length > 1 && masterNumberDOB && masterNumberDOB.length === 6) {
      const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
      if (masterNumberElem.length > 0) {
        let fixedMasterNumber = masterNumberElem.substring(0, 11)
        if (
          regex.test(masterNumberElem) &&
          !isNaN(masterNumberElem.substring(11)) &&
          fixedMasterNumber &&
          fixedMasterNumber.toLocaleLowerCase() === unidecode(getParsedMasterNumber().toLocaleLowerCase())
        ) {
          setMasterNumberValid(true)
          return true
        } else {
          setMasterNumberValid(false)
          setMasterNumberError('personal_info.master_number_error_invalid')
          return false
        }
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('personal_info.master_number_error')
        return false
      }
    }
  }

  const validateNSHealthCardNumber = (number) => {
    try {
      const [isValid, errorStr] = validateNSHealthNumber(number);
      setNSHealthCardNumberValid(isValid);
      setNSHealthCardNumberError(errorStr);
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <h2>{t('household_list.or_add_another')}</h2>
          <div className={styles['addrress-must-match-container']}>
            <i aria-label={t('shared.warning')} className={"fa fa-exclamation-triangle error-indicator fa-2x has-warning errorAlert " + styles['warning-alert']} aria-hidden="true"></i>
            <p>
              <strong>{t('household_list.this_address_must_match')}</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-12">
          <FirstName
            validateFirstName={validateFirstName}
            firstNameError={firstNameError}
            firstNameValid={firstNameValid}
            setIsError={setIsError}
          />
          <LastName
            validateLastName={validateLastName}
            lastNameError={lastNameError}
            lastNameValid={lastNameValid}
            setIsError={setIsError}
          />
          <DateOfBirth
            validateDateOfBirth={validateDateOfBirth}
            validateMasterNumber={validateMasterNumber}
            dateOfBirthError={dateOfBirthError}
            dateOfBirthValid={dateOfBirthValid}
            dateOfBirthDayEl={dateOfBirthDayEl}
            dateOfBirthMonthEl={dateOfBirthMonthEl}
            dateOfBirthYearEl={dateOfBirthYearEl}
            setIsError={setIsError}
          />
          {/* NS Health Card */}
          {
            nsHealthCard ? <NSHealthCardNumber
              validateNSHealthCardNumber={validateNSHealthCardNumber}
              nsHealthCardNumberError={nsHealthCardNumberError}
              nsHealthCardNumberValid={nsHealthCardNumberValid}
              setIsError={setIsError}
            /> : null
          }
          {/* Drivers License Master Number */}
          {
            driverLicence || registeredByName ?
              <MasterNumber
                validateMasterNumber={validateMasterNumber}
                masterNumberError={masterNumberError}
                masterNumberValid={masterNumberValid}
                setIsError={setIsError}
                isOptional={nsHealthCard}
              /> : null
          }
        </div>
      </div>
      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          // style={{ marginBottom: errMsg === '' ? '' : '5px' }}
          onClick={onAddHouseholdMember}
          value={t('household_list.add_household_member')}
          name={t('household_list.add_household_member')}
        >
          {t('household_list.add_household_member')}
        </button>{' '}
        {errMsg === '' ? '' : <i aria-label={t('shared.error')} className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(AddHouseholdMemberView)
